import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to BuildX",
    title: "Reliable {Construction Services} for Your Dream Project",
    buttonText: "Get Quote",
    buttonLink: "Get-Quote",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to BuildX",
    title: "Professional {Residential & Commercial} Construction",
    buttonText: "Get Quote",
    buttonLink: "Get-Quote",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to BuildX",
    title: "High-Quality {Custom Designs}, Renovations & Constructions",
    buttonText: "Get Quote",
    buttonLink: "Get-Quote",
  },
];

export default home;